import { createDecorator } from '../definition/decorator';
export const lifecycleRules = createDecorator('lifecycleRules', attach => (baseParams, runtime) => {
  let detached = false;
  const lifecycle = attach(baseParams, Object.assign({}, runtime, {
    next: state => {
      if (!detached) {
        runtime.next(state);
      }
    }
  }));
  return Object.assign({}, lifecycle, {
    detach: () => {
      lifecycle.detach();
      detached = true;
    }
  });
});